// Instance F's slot in A's feature registry.
//
// `registry.js` imports the page from `./claims/ClaimEditorStub`, so that file is
// the mount point and this module is the strand's public surface — what OTHER
// strands import.
//
// The only thing anyone outside needs is `openClaimEditor`: Instance E's ledger
// row calls it to open a specific claim, which is one line and needs no change to
// A's registry (which passes a page no claim id) and no new state management.

export { default as ClaimEditor } from './ClaimEditor';
export { default as ClaimEditorPage } from './ClaimEditorStub';
export {
  openClaimEditor,
  setClaimEditorTarget,
  readClaimEditorTarget,
  clearClaimEditorTarget,
} from './claimEditorTarget';

export const feature = 'claim_editor';
